import { render, staticRenderFns } from "./UpcomingIposFilters.vue?vue&type=template&id=055a0a29&scoped=true&"
import script from "./UpcomingIposFilters.vue?vue&type=script&lang=js&"
export * from "./UpcomingIposFilters.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingIposFilters.vue?vue&type=style&index=0&id=055a0a29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a0a29",
  null
  
)

export default component.exports